module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAiCAYAAADcbsCGAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJFJREFUeNrsmLEJgDAURH+CtbiE6AgO4EiZQSwyixPY6wiuoQ4QzzadiHDCHTxS5pFwPxCXUjKkBiPoQWkkKUADVlAZWTwYGMXuOFzrznSVuVwy0ngjjuQkJ7nshXicGOPrjUMI/z45DWEVQoVQIVQIFUKFkJzkJPep3MEsNzMP4RbrYqRfYBvowAROJrlLgAEARukrHr1+oFEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/buttons/MENU_N.png
// module id = K4LI
// module chunks = 18